/*
 * @Author: liuxw@codoon.com 
 * @Date: 2020-07-03 16:54:29 
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2020-07-03 18:48:50
 * @Content: 
 */

/**
 * address页面，url中参数的key
 */
 export const ADDRESS_URL_PARAM_KEY = {
    ACTIVITY_ID: "activityId",
    EMIT_ADDRESS: "emitAddress",
}

/**
 * address页面，将地址存入localStorage时使用的key
 */
export const LOCAL_STORAGE_ADDRESS_KEY = 'codoon.activity.address';

/**
 * 跳转至address页面时，可以在localStorage中设置的默认地址
 * 设置后，就不用再在address页面发送拿地址的请求
 */
export const LOCAL_STORAGE_DEFAULT_ADDRESS_KEY = 'codoon.activity.deafult_address';